<template>
  <v-card>
    <v-form ref="addCompany">
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_multiText :label="$t('label_company_name') + '*'"
                                 :isNational="judegNational('org_level_name')"
                                 v-model="params.org_level_name"
                                 :error-messages="
                  $errors('params', 'org_level_name', maxLength(20).concat(requiredRule))
                "></mrc_ess_multiText>
            </v-col>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_multiText :rules="$text_rules($t('label_Short_code'))"
                                 :label="$t('label_Short_code') + '*'"
                                 :isNational="judegNational('org_level_shortcode')"
                                 :error-messages="
                  $errors('params', 'org_level_shortcode', maxLength(10).concat(requiredRule))
                "
                                 v-model="params.org_level_shortcode"></mrc_ess_multiText>
            </v-col>
            <v-col cols="12"
                   sm="6">
              <!-- obj="{prompt_name:'org_level_relevance_client',client_uuid: $store.state.userData.currentCompany.values.client_uuid}" -->
              <mrc_ess_prompt :placeholder="$t('label_The_higher_the_unit')"
                              :rules="false"
                              :disabled="false"
                              :errMsg="$errors('params', 'org_level_code_parent', requiredRule)"
                              :label="$t('label_The_higher_the_unit') + '*'"
                              clearable
                              @getSelectItem="getSelectItem"
                              :obj="new_parent_org_level"
                              v-model="params.org_level_code_parent">
              </mrc_ess_prompt>
            </v-col>
            <v-col cols="12"
                   sm="6">
              <mrc_ess_NumInput :error-messages="
                  $errors('params', 'sequence', between('000-999').concat(requiredRule))
                "
                                v-model="params.sequence"
                                :label="$t('label_The_sorting') + '*'"></mrc_ess_NumInput>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-form>
    <mrc_ess_submitBtn @cancel="cancel"
                       :loading="loading"
                       @success="success"></mrc_ess_submitBtn>
  </v-card>
</template>

<script>
import { get_company_add } from "@/service/api/company_set"
import { required, maxLength, between } from "vuelidate/lib/validators"
export default {
  components: {},
  props: {},
  data () {
    return {
      loading: false,
      params: {
        org_level_name: "",
        org_level_shortcode: "",
        org_level_code_parent: '',
        sequence: "1",
        client_uuid: "",
      },
    }
  },
  validations: {
    params: {
      org_level_name: {
        required,
        maxLength: maxLength(20),
      },
      org_level_shortcode: {
        required,
        maxLength: maxLength(10),
      },
      sequence: {
        required,
        between: between(0, 999),
      },
      org_level_code_parent: {
        required,
      },
    },
  },
  created () {

  },
  async mounted () {
    await this.national("mrbase_sys_org_levels")
  },
  methods: {
    getSelectItem (obj) {
      this.params.client_uuid = this.$store.state.userData.clientUuid
    },
    //   添加单位
    async addCompany () {
      this.$v.params.$touch()
      if (this.$v.params.$error) return
      this.loading = true
      const add = await get_company_add({ ...this.params })
      if (add.code == 200) {
        this.$Message({ text: this.$t("message_The_operation_was_successful") })
        if (this.$store.state.topcompanylist.length <= 0) {
          if (
            this.$store.state.userData.userType != 1 &&
            this.$store.state.userData.userType != 4
          ) {
            await this.$store.dispatch("set_topcompanylist")
          }
        }
        this.$router.go(-1)
      }
      this.loading = false
    },
    //   取消
    cancel () {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then(() => {
          this.$router.go(-1)
        })
        .catch(() => { })
    },
    // 提交
    async success () {
      await this.addCompany()
    },
  },
  computed: {
    new_parent_org_level () {
      let obj = {}
      switch (this.$store.state.userData.userType) {
        case 2:
          obj = {
            prompt_name: "org_levels_manager_filter_company_code",
            // prompt_name: 'org_levels_manager_filter_company_company',
            user_id: this.$store.state.userData.user_id,
            org_level_code: this.$store.state.currentCompanyObj.org_level_code,
          }
          break
        case 3:
          obj = {
            prompt_name: "org_levels_manager_filter_company_code",
            // prompt_name: 'org_levels_manager_filter_company_company',
            user_id: this.$store.state.userData.user_id,
            org_level_code: this.$store.state.currentCompanyObj.org_level_code,
          }
          break
        default:
          obj = {
            prompt_name: "new_parent_org_level",
            user_id: this.$store.state.userData.user_id,
            client_uuid: this.$store.state.userData.clientUuid,
          }
      }
      return obj
    },
  },
  watch: {},
}
</script>

<style scoped></style>
